import { render, staticRenderFns } from "./recentAchievements.vue?vue&type=template&id=8fcf464e&scoped=true"
import script from "./recentAchievements.vue?vue&type=script&lang=js"
export * from "./recentAchievements.vue?vue&type=script&lang=js"
import style0 from "./recentAchievements.vue?vue&type=style&index=0&id=8fcf464e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcf464e",
  null
  
)

export default component.exports